import styled, { css } from 'styled-components';

export const cardContainer = css`
  display: grid !important;
  grid-template-rows: min-content 1fr;
  height: 100%;
  overflow: hidden;

  border-radius: 7px;

  @media (max-width: 640px) {
    height: auto !important;
  }
`;

export const imageBlock = css`
  object-fit: cover;
  object-position: 50% 50%;
  width: 100%;
  max-width: 100%;
  margin: 0;
  max-height: 260px;
  img {
    width: 100%;
  }
`;

export const textBlock = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 100%;
  overflow: hidden;
  > p {
    margin: 10px 0 0 0;
  }
  h4 {
    font-weight: 600;
    overflow-wrap: break-word;
  }

  .card-text {
    margin-bottom: 0 !important;
    p {
      margin-bottom: 0 !important;
    }
  }
`;

export const redSmallDateStyling = css`
  color: #e60000;
  font-size: 14px;
  padding-bottom: 15px;
`;

export const iconsAndTextContainer = css`
  padding-bottom: 4px;
`;

export const iconTextStyle = css`
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  padding: 0 24px;
  margin-bottom: 18px;

  svg {
    margin-right: 16px;
  }

  span {
    height: 100%;
    margin-top: -1px;
    overflow-wrap: anywhere;
  }
`;

export const imageIconStyle = css`
  width: 48px;
  height: 48px;
  position: absolute;
  bottom: -23px;
  z-index: 10;
  padding-top: 6px;
  padding-left: 7px;
  border-radius: 7px;
  background-color: #e60000;
`;

export const redTextLinkWrapper = css`
  color: #bd0000;
  width: fit-content;

  .red-text-link {
    display: flex;
    border-bottom: 0em solid transparent;
    cursor: pointer;

    :hover {
      text-decoration: underline;
    }
  }

  .red-text-link-icon {
    .injected-svg {
      stroke: #bd0000 !important;
    }
  }

  .red-text-link-label {
    padding-top: 1px;
  }

  @media (max-width: 640px) {
    display: none;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
`;

export const TextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 20px;
`;
